import { Base } from "@studiometa/js-toolkit";
import { transition } from "@studiometa/js-toolkit/utils";
class Tabs extends Base {
  /**
   * Config.
   */
  static config = {
    name: "Tabs",
    refs: ["btn[]", "content[]"],
    emits: ["enable", "disable"],
    options: {
      styles: {
        type: Object,
        default: () => ({
          content: {
            closed: {
              position: "absolute",
              opacity: "0",
              pointerEvents: "none",
              visibility: "hidden"
            }
          }
        }),
        merge: true
      }
    }
  };
  items;
  /**
   * Initialize the component's behaviours.
   * @returns {void}
   */
  mounted() {
    this.items = this.$refs.btn.map((btn, index) => {
      const id = `${this.$id}-${index}`;
      const content = this.$refs.content[index];
      btn.setAttribute("id", id);
      content.setAttribute("aria-labelledby", id);
      const item = { btn, content, isEnabled: index > 0 };
      if (index > 0) {
        this.disableItem(item);
      } else {
        this.enableItem(item);
      }
      return item;
    });
  }
  /**
   * Switch tab on button click.
   */
  onBtnClick({ index }) {
    this.items.forEach((item, i) => {
      if (i !== index) {
        this.disableItem(item);
      }
    });
    this.enableItem(this.items[index]);
  }
  /**
   * Enable the given tab and its associated content.
   */
  async enableItem(item) {
    if (!item || item.isEnabled) {
      return Promise.resolve(this);
    }
    item.isEnabled = true;
    const { btn, content } = item;
    const btnStyles = this.$options.styles.btn || {};
    const contentStyles = this.$options.styles.content || {};
    content.setAttribute("aria-hidden", "false");
    this.$emit("enable", item);
    return Promise.all([
      transition(
        btn,
        {
          from: btnStyles.closed,
          active: btnStyles.active,
          to: btnStyles.open
        },
        "keep"
      ),
      transition(
        content,
        {
          from: contentStyles.closed,
          active: contentStyles.active,
          to: contentStyles.open
        },
        "keep"
      )
    ]).then(() => Promise.resolve(this));
  }
  /**
   * Disable the given tab and its associated content.
   */
  async disableItem(item) {
    if (!item || !item.isEnabled) {
      return Promise.resolve(this);
    }
    item.isEnabled = false;
    const { btn, content } = item;
    const btnStyles = this.$options.styles.btn || {};
    const contentStyles = this.$options.styles.content || {};
    content.setAttribute("aria-hidden", "true");
    this.$emit("disable", item);
    return Promise.all([
      transition(
        btn,
        {
          from: btnStyles.open,
          active: btnStyles.active,
          to: btnStyles.closed
        },
        "keep"
      ),
      transition(
        content,
        {
          from: contentStyles.open,
          active: contentStyles.active,
          to: contentStyles.closed
        },
        "keep"
      )
    ]).then(() => Promise.resolve(this));
  }
}
export {
  Tabs
};
//# sourceMappingURL=Tabs.js.map
